namespace $ {

	export class $shm_hitalama_map_presence extends $giper_baza_entity.with({
		Profile: $giper_baza_atom_link.to( ()=> $shm_hitalama_profile ),
		Pos: $giper_baza_atom_list,
		Time: $giper_baza_atom_real,
	}){}

	export class $shm_hitalama_map_presence_dict extends $giper_baza_dict_to(
		$giper_baza_atom_link.to( ()=> $shm_hitalama_map_presence )
	) {}

}
